const encoder = new TextDecoder()

/**
 * Converts a Uint8Array or ArrayBuffer to a string using UTF-8 decoding.
 *
 * @param value - The Uint8Array or ArrayBuffer to decode
 * @returns The decoded string
 *
 * @example
 * ```ts
 * import { StringToUInt8, UInt8ToString } from "@pdfking/tfunc"
 *
 * UInt8ToString(new Uint8Array([72, 101, 108, 108, 111])) // "Hello"
 *
 * // Round-trip conversion
 * UInt8ToString(StringToUInt8("Hello, World!")) === "Hello, World!" // true
 * ```
 */
export const UInt8ToString = (value: Uint8Array | ArrayBuffer): string => encoder.decode(value)
